import React, { Component } from "react";
import ProjectTabsAndActions from './project-tabs-and-actions'
import BtButton from "../bt-button/bt-button"
import appState from '../../state/AppStateContainer';
import axios from "axios";
import BackButton from "../../components/shared/BackButton/BackButton";
import BtGrid from "../bt-grid/bt-grid";
import BtRow from "../bt-row/bt-row";
import BtColumn from "../bt-column/bt-column";
import AppLayout from "../../components/layout/app-layout/app-layout";
import HTMLParser from "../../components/shared/HTMLParser/HTMLParser";
import Editor from "../../components/shared/Editor/Editor";
import { withTranslation, Trans } from "react-i18next";

export class ProjectStrategy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      strategy: "",
    };
  }

  async handleSubmit() {
    let strategy = this.state.strategy;
    try {
      this.setState({ loaderShow: true });
      await this.updateStrategy(this.props.projectSlug, strategy);

      if (this.props.onStrategyUpdated) {
        this.props.onStrategyUpdated(this, strategy);
      }
      this.setState({ loaderShow: false });
    } catch (error) {
      console.error(error);
      this.setState({ loaderShow: false });
    }
  }

  async updateStrategy(projectSlug, strategy) {
    const response = await axios.put("/api/project/" + projectSlug + "/strategy", { strategy });
    return response.data;
  }

  componentDidMount() {
    this.setState({ strategy: this.props.strategy });
  }

  render() {
    const {t} = this.props;
    const step = 0;
    // Get the referrer URL from location state (stored when navigating from projects list)
    const projectsListUrl = this.props.history.location.state?.fromProjectsList || '/projects';
    return (
      <AppLayout title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <BackButton to={projectsListUrl} />
          <div className="page-title">{this.props.currentProject.name}</div>
        </div>
      }>
        <div className="section-strategy">
          <BtGrid>
            <BtRow>
              <BtColumn className="column-content" style={{flexDirection: "column"}}>
                <ProjectTabsAndActions
                  currentProject={this.props.currentProject}
                  selected={step}
                  onChange={this.props.onStepChange}
                  onNewEvaluation={this.props.onNewEvaluation}
                  onErfaNew={this.props.onErfaNew}
                  onNewArea={this.props.onNewArea}
                  history={this.props.history}
                />
                <div className="app-project-settings">
                  <div className="left--style">
                    <Trans t={t} i18nKey="intro" />
                    <p>
                      <strong>{t('usp.heading', 'Besluten kan variera mellan nedanstående strategiska val, t.ex.:')}</strong>
                    </p>
                    <ul className="listing bullet--style">
                      <Trans t={t} i18nKey="usp.list" components={{li: <li />}} />
                    </ul>
                  </div>
                  <div className="right--style">
                    <div style={{ height: 'calc(100% - 80px)' }}>
                      { appState.isWriteAccessRole() ? (
                        <div style={{ height: '100%' }}>
                          <Editor value={this.state.strategy} onChange={value => this.setState({ strategy: value })} />
                        </div>
                      ) : (
                        <div><HTMLParser data={this.state.strategy} /></div>
                      )}
                    </div>
                    { appState.isWriteAccessRole() && (
                    <div className="clearfix">
                      <BtButton
                        class="btn-right bt-modal-hides"
                        loaderShow={this.state.loaderShow}
                        type="submit"
                        onClick={this.handleSubmit.bind(this)}
                      >{t('button.save', 'Spara')}</BtButton>
                    </div>
                  )}
                  </div>
                </div>
              </BtColumn>
            </BtRow>
          </BtGrid>
        </div>
      </AppLayout>
    );
  }
}

export default withTranslation('projects', { keyPrefix: 'strategy' })(ProjectStrategy);
